<template>
  <main>
    <PageIntro v-if="appLogin === false"
      :heading="'Register for an <span>' + configStrings.clubName + ' ' +configStrings.productName + '</span>'"
      :body="'<p>Enter your details below to create your ' + configStrings.clubName + ' ' +configStrings.productName + '.</p><p>Once signed up, you’ll be able to purchase tickets and get exclusive access to ' + configStrings.clubName + ' content as well as a host of other benefits. This is a one-time registration required with your email.</p>'" />
    <PageIntro v-else
      :heading="'Register for an <span>' + configStrings.clubName + ' ' +configStrings.productName + '</span>'"
      :body="''" />
    <RegistrationFull />
    <FooterShout v-if="appLogin === false" :type="'signin'"/>
  </main>
</template>

<script>
  import RegistrationFull from '@/components/RegistrationFull'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      RegistrationFull,
      PageIntro,
      FooterShout
    },
    data() {
      return {
        appLogin: false
      }
    },
    mounted () {
      // if they are coming from the app specific login URL adapt the page accordingly
      if(this.$router.currentRoute.name === 'app-register'){
        this.appLogin = true
      }
    },
  }
</script>
